"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("../core/Observable");
exports.createSubject = function (_a) {
    var initial = (_a === void 0 ? {} : _a).initial;
    var observers = new Set();
    var mode = initial !== undefined ? 1 /* Behavior */ : 0 /* Publish */;
    var lastValue = initial;
    var completed = false;
    var error;
    var observable = new Observable_1.Observable(function (observer) {
        if (error) {
            observer.error(error);
            return;
        }
        if (mode === 1 /* Behavior */) {
            observer.next(lastValue);
        }
        if (completed) {
            observer.complete();
            return;
        }
        observers.add(observer);
        return function () { return observers.delete(observer); };
    });
    var sink = {
        get closed() {
            return completed;
        },
        next: function (value) {
            if (mode === 1 /* Behavior */) {
                lastValue = value;
            }
            observers.forEach(function (observer) { return observer.next(value); });
        },
        error: function (reason) {
            completed = true;
            error = reason;
            observers.forEach(function (observer) { return observer.error(reason); });
            observers.clear();
        },
        complete: function () {
            completed = true;
            observers.forEach(function (observer) { return observer.complete(); });
            observers.clear();
        }
    };
    return [observable, sink];
};
//# sourceMappingURL=subject.js.map